import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components
import styles from "../ServicesSections.module.scss";



export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Google Tag Manager Training</h3>
          <p>
            Tribalism is a web analytics, cloud infrastructure and digital
            marketing company with office space in Sydney and Melbourne
            Australia. We have delivered multiple in-house Google Tag Manager
            training sessions across Australia and overseas. We are recognised
            locally as leaders in the space with a growing reputation
            internationally as well.
            <br />
            <br />
            We’d love to assist you and your team get to grips with Google Tag
            Manager and the rest of the Google Cloud stack as well.
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>What to expect:</h3>
          <p>
            Sessions vary as to your requirements, but some of the areas covered
            may include:
          </p>
          <ul>
            <li>
              Basic training: what is Google Tag Manager, why is it important,
              simple hands-on container implementation run through, review of
              in-built tagging templates
            </li>
            <li>
              Intermediate run-through: use cases for Google Tag Manager, review
              of your website for current areas of how Google Tag Manager is
              being implemented and how it could be implemented better
            </li>
            <li>
              Advanced Tag Management: form tracking, video tracking, enhanced
              ecommerce implementation, advanced container management
            </li>
            <li>
              Custom tagging: 2nd time visitors v multiple time visitors, 3rd
              party tags eg openweather, conversion rate optimization
            </li>
          </ul>
        </GridItem>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/sections/services/google-tag-manager-training/1.jpg"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>Google Tag Manager Interface</i>
            </p>
          </GridItem>
        </div>

        <div style={{ textAlign: "center", maxWidth: "800px", width: "100%" }}>
          <GridItem xs={12} sm={12} md={12}>
            <img
              src="/img/sections/services/google-tag-manager-training/2.jpg"
              alt="..."
              className={imgClasses}
            />

            <p>
              <br></br>
              <i>An Example Tag: Repeat Session Cookie Deploy</i>
            </p>
          </GridItem>
        </div>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Flexible to your plans:</h3>
          <p>
            It is easy for us to come to you, wherever you are across Australia,
            New Zealand or the Asia Pacific region.
            <br />
            <br />
            Training agendas will be agreed with you in advance. If you like we
            can design the agenda completely for you, or if you have specific
            areas you’d like to cover we can tailor the agenda to your areas of
            focus.
            <br />
            <br />
            Or rates are very competitive and will be agreed with you in
            advance. If you are interested please don’t hesitate to drop us a
            line so we can get your Google Tag Manager implementation up and
            running or fine tune it so it is running in top shape.
          </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>
          <h3 className={classes.title}>Our guarantee to you</h3>

          <ol>
            <li>
              Quality: We will deliver quality work. It's the first thing all of
              our staff are trained in - “completed” is not good enough - it
              needs to be done well!
            </li>
            <li>
              Communication: We cannot guarantee that everything will be perfect
              the first time. Most things aren't. But what we can guarantee is
              easy communication to anyone in our business to discuss any issues
              and fix any problems asap.
            </li>
            <li>
              Innovative: We are anti-silo. Like life - you can't just focus on
              one thing to fix your problems. We are well versed on every facet
              of this field - and with that comes innovative approaches to your
              business issues.
            </li>
          </ol>

          <br />
          <br />
          <br />
        </GridItem>
      </GridContainer>
    </div>
  );
}
